import React from 'react';
import { TYPE_COLORS } from '../../utils/constants';
import { formatRelative } from '../../utils/dates';
import Badge from '../shared/Badge';

function RecentEntriesList({ entries = [], onEntryClick }) {
  if (!entries.length) return <div className="list-empty">Sin entradas recientes</div>;
  return (
    <div className="item-list">
      {entries.map(e => {
        const typeInfo = TYPE_COLORS[e.entry_type] || TYPE_COLORS.otro;
        return (
          <div
            key={e.id}
            className="item-row clickable"
            onClick={() => onEntryClick?.(e.id)}
          >
            <div className="item-row__main">
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                <Badge label={typeInfo.label} color={typeInfo.color} />
                {e.project && <span className="meta-chip">{e.project}</span>}
                <span className="meta-chip">{formatRelative(e.created_at)}</span>
              </div>
              <span className="item-row__title" style={{ fontWeight: 400, color: 'var(--text-muted)' }}>
                {e.content?.slice(0, 80)}{e.content?.length > 80 ? '…' : ''}
              </span>
            </div>
            <span style={{ color: 'var(--text-dim)', fontSize: 16 }}>›</span>
          </div>
        );
      })}
    </div>
  );
}

export default RecentEntriesList;
